const serialize = (paramsObject) => Object.keys(paramsObject)
  .filter((key) => paramsObject[key] !== undefined)
  .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`).join('&');

export default serialize;
